/* Used [use-categories.js] as base */
import {useContext} from 'react'
import {HeaderContext} from '../contexts'

export const useHeader = () => {
    const context = useContext(HeaderContext)
    if (context === undefined) {
        throw new Error('useHeader must be used within HeaderProvider')
    }
    return {
        headerWrapper: context.current?.parentElement,
        header: context.current
    }
}
